import axios from "axios";
// import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

// const common = () => {
//   const auth = store.commonState().auth;
//   const auth_key = auth.user.auth_key;
//   const action = `afterlogin/user`;
//   const data = {
//     action: action,
//     auth_key,
//   };
//   return axios.post(API_URL + action, data, { headers: authHeader() });
// };

const timezone = () => {
  const action = "common/timezone";
  var data = {
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const sampleClientExport = (values) => {
  const action = "common/sampleclientexport";
  const salonId = values && (values.salon_id ?? values.id);
  const payload = salonId === undefined || salonId === null || salonId === ""
    ? {}
    : { salon_id: salonId };
  return axios.post(API_URL + action, {
    ...payload,
  }, { headers: authHeader(), responseType: "blob" });
};

const sampleProductExport = (values) => {
  const action = "common/sampleproductexport";
  const data = {
    salon_id:values && values.id ? values.id : ""
  };
  return axios.post(API_URL + action, data, {
    headers: authHeader(),
    responseType: "blob",
  });
};

const whentosend = (values) => {
  const action = "common/whentosend";
  const data = {
    campaign_type: values && values.campaign_type,
    type: values && values.type,
  };
  if (values && values.option !== undefined) {
    data.option = values.option;
  }
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const checkuser = (values) => {
  const formData = new FormData();
  ["uid", "email", "phone_number"].forEach((value) => {
    if (values?.[value] !== undefined && values[value] !== null) formData.append(value, values[value]);
  });
  const action = "common/checkuser";
  return axios.post(API_URL + action, formData, { headers: authHeader() });
};


const commonApiController = {
  timezone,
  sampleClientExport,
  sampleProductExport,
  whentosend,
  checkuser
};

export default commonApiController;
